import { render } from "./menuSidebar.vue?vue&type=template&id=8600ec9e"
import script from "./menuSidebar.vue?vue&type=script&lang=js"
export * from "./menuSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__